import { c as _c } from "react/compiler-runtime";
import type { SpacingValue } from '@newfront-insurance/core-ui';
import { Portal, Padding } from '@newfront-insurance/core-ui';
import type { NextApiErrorLike } from '@newfront-insurance/data-layer-http';
import { usePageTitle } from '@newfront-insurance/react-hooks';
import * as React from 'react';
import type { JSX } from 'react';
import styled from 'styled-components';
import { getErrorPageTitle, getDefaultErrorTitle, getDefaultErrorText } from '../utils';
import { ErrorCard } from './components/error-card';
interface Props {
  error: NextApiErrorLike;
  title?: string;
  body?: React.ReactNode;
  top?: SpacingValue;
}

/**
 * Render an overlay that takes over the page with details about a NextApiError
 */
export function ErrorOverlay(props) {
  const $ = _c(15);
  const {
    error,
    title,
    body,
    top: t0
  } = props;
  const top = t0 === undefined ? 56 : t0;
  let t1;
  if ($[0] !== error) {
    t1 = getErrorPageTitle(error);
    $[0] = error;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  usePageTitle(t1);
  let t2;
  if ($[2] !== error || $[3] !== title) {
    t2 = title || getDefaultErrorTitle(error);
    $[2] = error;
    $[3] = title;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== body || $[6] !== error) {
    t3 = body || getDefaultErrorText(error);
    $[5] = body;
    $[6] = error;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== error || $[9] !== t2 || $[10] !== t3) {
    t4 = <ErrorCard title={t2} body={t3} error={error} />;
    $[8] = error;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t4 || $[13] !== top) {
    t5 = <Portal name="error"><StyledOverlay><Padding top={top}>{t4}</Padding></StyledOverlay></Portal>;
    $[12] = t4;
    $[13] = top;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}
const StyledOverlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.5);
  z-index: 10;
`;